<template>

<!DOCTYPE html>
<html lang="pt-br">
<head>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Assistência Técnica Autorizada Canon para Impressoras Jato de Tinta</title>
</head>
<body style="padding: 40px;">
<table width="100%" border="0" align="center" cellpadding="0" cellspacing="0" style="border:#000000 1px solid;">
  <tbody>
    <tr>
      <td align="center"><table width="90%" border="0" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td height="80" align="center">&nbsp;</td>
          </tr>
          <tr>
            <td align="center"><img src="@/assets/img/canon_logo.svg" alt="" width="60%"/></td>
          </tr>
          <tr>
            <td height="60" align="center">&nbsp;</td>
          </tr>
          <tr>
            <td align="center" style="font-family: 'Helvetica Neue', Helvetica, Arial, 'sans-serif'; font-size: 24pt;">A Canon do Brasil certifica que a empresa</td>
          </tr>
          <tr>
            <td height="30" align="center">&nbsp;</td>
          </tr>
          <tr>
            <td align="center" style="font-family: 'Helvetica Neue', Helvetica, Arial, 'sans-serif'; font-size: 32pt; font-weight: bold;">
              {{ asf.asf.name }} <br>
              {{ asf.asf.vat }}
            </td>
          </tr>
          <tr>
            <td height="30" align="center">&nbsp;</td>
          </tr>
          <tr>
            <td align="center" style="font-family: 'Helvetica Neue', Helvetica, Arial, 'sans-serif'; font-size: 24pt;">é uma assistência técnica autorizada para impressoras jato de tinta.</td>
          </tr>
          <tr>
            <td height="120" align="center">&nbsp;</td>
          </tr>
          <tr>
            <td align="center" valign="top">
              <table width="100%" border="0" align="center" cellpadding="0" cellspacing="0">
                <tbody>
                  <tr>
                    <td align="center" style="font-family: 'Helvetica Neue', Helvetica, Arial, 'sans-serif'; font-size: 24pt; font-weight: bold;">Canon do Brasil</td>
                  </tr>
                  <tr>
                    <td align="center" style="font-family: 'Helvetica Neue', Helvetica, Arial, 'sans-serif'; font-size: 18pt;">Certificado válido de {{ this.$moment(asf.asf.initial_date).format('DD/MM/YYYY') }} a {{ this.$moment(asf.asf.expiry_date).format('DD/MM/YYYY') }}.</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td height="40" align="center">&nbsp;</td>
          </tr>
          </tbody>
      </table></td>
    </tr>
  </tbody>
</table>

  
</body>
</html>
</template>

<script>
import { mapState } from "vuex";
import NotFound from "@/pages/NotFoundPage.vue";

export default {
  name: "Certified",
  beforeCreate() {
    this.$store.dispatch("asfs/getByCode", this.$route.params.token)
    .then((response) => {
      if ( !response.asf ) {
        return this.$router.push('/404');
      }      
    })
  },
  computed: {
    ...mapState("asfs", {
      asf: "asf"
    })
  },
  data() {
    return{      
    }
  },
  methods: {
  }
};
</script>

<style type="text/css">
		.table_bottom {
			display: inline-block;
		}
		.table_bottom_left {
			padding-left:20%;
		}
		
		@media only screen and (max-width: 800px) {
			.table_bottom {
				display: table;
				width: 100%;
			}
			.table_bottom td{
				text-align: center;
			}
			.table_bottom td table{
				margin: 0 auto;
			}
			.table_bottom_left {
				padding-left:0;
				padding-bottom: 60px;
			}
		
		}
</style>